import { jsx as i, jsxs as k } from "react/jsx-runtime";
import { createElement as B } from "react";
import { c as a } from "./extends-2c39a7b4.js";
import { C as T, R as p, a as M } from "./getButtonHref-4b514703.js";
import { V as G } from "./Button-ac33fe97.js";
import { C as l } from "./ContentRenderer-b6eef314.js";
import "./helpers-7c298f27.js";
import "./Parent-2cc4d070.js";
import "./pp-react-theme.esm-ef1d004f.js";
import "./pp-react-icons.esm-6f29efc7.js";
import "./propsChecker-7de44c11.js";
const H = "_keyMetricsTextContainer_92i3l_1", R = "_keyMetricsDescription_92i3l_5", I = "_keyMetricItem_92i3l_11", f = "_keyMetricText_92i3l_22", v = "_keyMetricsBgWhite_92i3l_29", W = "_keyMetricsBgGrey_92i3l_32", w = "_keyMetricsBgNeutral100_92i3l_35", F = "_keyMetricsContainer_92i3l_38", S = "_keyMetricsFontGreen_92i3l_42", P = "_keyMetricsHeadline_92i3l_42", b = "_keyMetricsFontBlue_92i3l_47", D = "_headlineText_92i3l_54", E = "_keyMetricsCol_92i3l_58", j = "_hasHeadline_92i3l_64", L = "_keyMetricsColRegularPadding_92i3l_67", V = "_keyMetricsSeparator_92i3l_116", q = "_textHeader_92i3l_133", K = "_keyMetricItemContainer_92i3l_193", U = "_parentRow_92i3l_208", e = {
  keyMetricsTextContainer: H,
  keyMetricsDescription: R,
  keyMetricItem: I,
  keyMetricText: f,
  keyMetricsBgWhite: v,
  keyMetricsBgGrey: W,
  keyMetricsBgNeutral100: w,
  keyMetricsContainer: F,
  keyMetricsFontGreen: S,
  keyMetricsHeadline: P,
  keyMetricsFontBlue: b,
  headlineText: D,
  keyMetricsCol: E,
  hasHeadline: j,
  keyMetricsColRegularPadding: L,
  keyMetricsSeparator: V,
  textHeader: q,
  keyMetricItemContainer: K,
  parentRow: U
};
var _ = /* @__PURE__ */ ((t) => (t.Blue = "Blue", t.Green = "Green", t))(_ || {}), o = /* @__PURE__ */ ((t) => (t.Grey = "Grey", t.White = "White", t.Neutral100 = "Neutral 100", t))(o || {});
const y = "KeyMetrics", $ = (t) => /* @__PURE__ */ i("div", { className: e.keyMetricItemContainer, children: t.map((s, n) => /* @__PURE__ */ B(A, { ...s, key: `keyMetricItem-${n + 1}` })) }), z = (t, s) => {
  const n = t - 1, m = [];
  for (let r = 0; r < n * n; r += 2)
    m.push(
      /* @__PURE__ */ i(
        M,
        {
          sm: 12,
          className: a(
            e.keyMetricsCol,
            e.keyMetricsColRegularPadding
          ),
          children: $(s.slice(r, r + 2))
        },
        r
      )
    );
  return m;
};
function A({ headline: t, textHeader: s, text: n }) {
  return /* @__PURE__ */ k("div", { className: e.keyMetricItem, children: [
    t && /* @__PURE__ */ i(
      l,
      {
        content: t,
        analyticsCompName: y,
        analyticsTextSection: "ItemHeadline",
        className: e.headlineText
      }
    ),
    s && /* @__PURE__ */ i(
      l,
      {
        as: "p",
        content: s,
        analyticsCompName: y,
        analyticsTextSection: "ItemHeadline",
        className: e.textHeader
      }
    ),
    /* @__PURE__ */ i(
      l,
      {
        as: "p",
        analyticsCompName: y,
        analyticsTextSection: "ItemParagraph",
        className: e.keyMetricText,
        content: n
      }
    )
  ] });
}
const u = ({
  backgroundColor: t = o.White,
  className: s,
  collection: n = [],
  columns: m = 2,
  cta: r,
  fontColor: C = _.Blue,
  headline: c,
  text: d,
  ...N
}) => {
  const h = a(
    e.keyMetricsContainer,
    C === _.Green ? e.keyMetricsFontGreen : e.keyMetricsFontBlue,
    s
  ), x = z(m, n), g = c ? "p" : "h2";
  return /* @__PURE__ */ i(
    "section",
    {
      className: a({
        [e.keyMetricsBgGrey]: t === o.Grey,
        [e.keyMetricsBgWhite]: t === o.White,
        [e.keyMetricsBgNeutral100]: t === o.Neutral100
      }),
      children: /* @__PURE__ */ i(T, { className: h, ...N, children: /* @__PURE__ */ k(p, { className: e.parentRow, align: "center", children: [
        /* @__PURE__ */ k(
          M,
          {
            sm: 12,
            md: 6,
            className: a(
              e.keyMetricsCol,
              c && e.hasHeadline
            ),
            children: [
              c && /* @__PURE__ */ i("div", { className: e.keyMetricsHeadline, children: /* @__PURE__ */ i(l, { content: c }) }),
              /* @__PURE__ */ k("div", { className: e.keyMetricsTextContainer, children: [
                d && /* @__PURE__ */ i(
                  l,
                  {
                    className: e.keyMetricsDescription,
                    as: g,
                    analyticsCompName: y,
                    content: d
                  }
                ),
                r && /* @__PURE__ */ i(
                  G,
                  {
                    optional: !0,
                    className: e.resourceButton,
                    type: r.type,
                    href: r.url,
                    mobileHref: r.mobileUrl,
                    target: r.target,
                    theme: r.theme,
                    text: r.text,
                    clickEventName: r.clickEventName,
                    ariaLabel: r.ariaLabel,
                    mabReward: r.mabReward
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ i(
          M,
          {
            sm: 12,
            md: 6,
            className: a(
              e.keyMetricsCol,
              c && e.keyMetricsSeparator
            ),
            children: /* @__PURE__ */ i(p, { children: x })
          }
        )
      ] }) })
    }
  );
};
u.requiredProps = {
  backgroundColor: !0,
  columns: !0,
  fontColor: !0
};
u.displayName = y;
export {
  u as default
};
//# sourceMappingURL=KeyMetricsType.js.map
